import { useState, useRef, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { authService } from "../services/authService";
import TablerLayout from "../components/layout/TablerLayout";
import FloatingLabelInput from "../components/form_elements/FloatingLabelInput";

const Login = () => {
    const appVersion = process.env.REACT_APP_VERSION;
	const { login } = useAuth();
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(false);
	const [formData, setFormData] = useState({ username: "", password: "" });
    const passwordInputRef = useRef(null);

    useEffect(() => {
        if (error && passwordInputRef.current) {
            passwordInputRef.current.select();
        }
    }, [error]);

	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleFocus = (e) => {
		e.target.placeholder = "";
	};

	const handleBlur = (e, defaultText) => {
		if (e.target.value === "") {
			e.target.placeholder = defaultText;
		}
	};

	const handleLogin = async (e) => {
		e.preventDefault();
		setError("");
		setLoading(true);

		try {
			if (!navigator.onLine) {
				throw new Error("Nincs internetkapcsolat");
			}

			const result = await authService.login(formData.username, formData.password);

			if (result.status === "ok") {
				login();
			} else {
				setError("Hibás felhasználónév vagy jelszó");
			}
		} catch (err) {
			console.error("Login error:", err);
			setError(err.message === "Időtúllépés" || err.message === "Nincs internetkapcsolat" ? err.message : "A szerverrel való kommunikáció során hiba történt");
		} finally {
			setLoading(false);
		}
	};

	return (
        <div 
            className="min-vh-100 d-flex align-items-center justify-content-center"
            style={{ 
                backgroundColor: 'var(--primary-color)',
                background: 'linear-gradient(135deg, var(--primary-color) 0%, #4a7c59 100%)',
                padding: '1rem'
            }}
        >
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
                        <div 
                            className="card"
							style={{
								backgroundColor: 'white',
								boxShadow: '2rem 1rem 6rem rgba(255, 255, 255, 0.65)'
							}}
                        >
                            <div className="card-body p-4 p-md-5">
                                <div className="text-center mb-4">
                                    <img 
                                        src="/images/elitcipo-logo.png" 
                                        height="80" 
                                        alt="Elit Cipő"
                                        className="mb-3"
                                    />
                                    <h5 className="text-dark">
                                        Üdvözöljük az Elit Cipő rendelési rendszerében!
                                    </h5>
                                </div>

                                {/* Login form */}
                                <form onSubmit={(e) => { handleLogin(e); return false; }} autoComplete="off" noValidate>
                                        <div className="mb-3">
                                        <FloatingLabelInput
                                            type="text"
                                            label="Felhasználónév"
                                            id="username"
                                            className={`form-control ${error ? "is-invalid" : ""}`}
                                            name="username"
                                            value={formData.username}
                                            onChange={handleChange}
                                            onFocus={handleFocus}
                                            onBlur={(e) => handleBlur(e, "Adja meg a felhasználónevét!")}
                                            autoFocus={true}
                                        />
                                    </div>
                                    
                                    <div className="mb-4">
                                        <FloatingLabelInput
                                            ref={passwordInputRef}
                                            type="password"
                                            label="Jelszó"
                                            id="password"
                                            className={`form-control ${error ? "is-invalid" : ""}`}
                                            name="password"
                                            value={formData.password}
                                            onChange={handleChange}
                                            onFocus={handleFocus}
                                            onBlur={(e) => handleBlur(e, "Adja meg a jelszavát!")}
                                        />
                                        {error && <div className="invalid-feedback">{error}</div>}
                                    </div>

                                     {/* Hibaüzenet megjelenítése */}
                                    {error && (
                                        <div className="alert alert-danger py-2 mb-3 text-center" role="alert">
                                            {error}
                                        </div>
                                    )}
                                    
                                    <div className="d-grid">
                                        <button 
                                            type="submit" 
                                            className="btn btn-primary btn-lg"
                                            disabled={loading || !formData.username || !formData.password}
                                            style={{
                                                padding: '0.3rem 1rem'
                                            }}
                                        >
                                            {loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Bejelentkezés...
                                                </>
                                            ) : (
                                                "Belépés"
                                            )}
                                        </button>
                                    </div>
                                    {appVersion && (
                                        <div className="position-absolute bottom-0 end-0 p-1 text-muted" style={{ fontSize: '0.6rem' }}>
                                            v.{appVersion}
                                        </div>
                                    )}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
